
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.rep-photo-img').forEach(function(img) {
    if (img.src.includes('No+Img')) {
      img.classList.add('hide_cls');
    }
  });
});


document.addEventListener('DOMContentLoaded', function() {
  const checkboxes = document.querySelectorAll('.terms-checkbox'); // all checkboxes
  const buyButtons = document.querySelectorAll('.terms-buy-btn');
  const errorMessages = document.querySelectorAll('.error-msg');

  // Helper: check if any checkbox is checked
  function anyChecked() {
    return Array.from(checkboxes).some(cb => cb.checked);
  }

  // Enforce button states every 300ms
  setInterval(() => {
    if (!anyChecked()) {
      buyButtons.forEach(btn => btn.disabled = true);
    }
  }, 300);

  // On any checkbox change
  checkboxes.forEach(cb => {
    cb.addEventListener('change', function () {
      if (anyChecked()) {
        buyButtons.forEach(btn => btn.disabled = false);
        errorMessages.forEach(msg => msg.style.display = 'none');
      } else {
        buyButtons.forEach(btn => btn.disabled = true);
        errorMessages.forEach(msg => msg.style.display = 'block');
      }
    });
  });

  // On button click
  buyButtons.forEach((btn) => {
    btn.addEventListener('click', function(e) {
      if (!anyChecked()) {
        e.preventDefault();
        buyButtons.forEach(b => b.disabled = true);
        errorMessages.forEach(msg => msg.style.display = 'block');
      }
    });
  });
});


// Exposed so quick-add.js can bind quantity inputs it injects after page load.
window.bindVolumeProperties = function(root) {
  // Find all quantity inputs under root
  root.querySelectorAll('.quantity__input').forEach(function(qtyInput) {
    if (qtyInput.dataset.volumeBound) return;
    qtyInput.dataset.volumeBound = 'true';
    // Function to update hidden property inputs
    // bvOnly: rescale just Business Volume (used on load, see below).
    function updateProperties(bvOnly) {
      const qty = parseInt(qtyInput.value, 10) || 1;
      // Scope: the closest form that holds hidden properties
      const form = document.querySelector('#' + qtyInput.getAttribute('form'));
      if (!form) return;
      form.querySelectorAll('input[name^="properties["][data-base]').forEach(function(input) {
        if (bvOnly === true && input.name !== 'properties[Business Volume]') return;
        const base = parseFloat(input.getAttribute('data-base'));
        if (!isNaN(base)) {
          // Business Volume is a whole number (truncated), matching apex-attribution.js;
          // other properties keep two decimals.
          input.value = input.name === 'properties[Business Volume]'
            ? String(Math.trunc(Math.round(base * qty * 1e6) / 1e6))
            : (base * qty).toFixed(2);
        }
      });
    }

    // The quantity can start above 1 (quantity_rule.min), but the Liquid value
    // is one unit's BV, so scale Business Volume to the initial quantity now.
    updateProperties(true);

    // Listen to both typing and clicking plus/minus
    qtyInput.addEventListener('input', updateProperties);
    qtyInput.addEventListener('change', updateProperties);

    // Also attach to the plus/minus buttons next to it
    const container = qtyInput.closest('quantity-input');
    if (container) {
      container.querySelectorAll('.quantity__button').forEach(function(btn) {
        btn.addEventListener('click', function() {
          // Wait a tick for Dawn JS to update the input value
          setTimeout(updateProperties, 50);
        });
      });
    }
  });
};

document.addEventListener('DOMContentLoaded', function() {
  window.bindVolumeProperties(document);
});

// document.addEventListener("DOMContentLoaded", function() {
//   const cusBtns = document.querySelectorAll(".cusCheckout");
  
//   cusBtns.forEach(function(cusBtn) {
//     cusBtn.addEventListener("click", function(e) {
//       // Stop all default behaviors
//       e.preventDefault();
//       e.stopImmediatePropagation();

//       // Force redirect to cart with auto-checkout param
//       window.location.href = "/cart?auto_checkout=true";
//     });
//   });
// });




document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".membership-navigation button, .membership-button button");
  const target = document.querySelector(".custom-product-content");

  buttons.forEach(button => {
    button.addEventListener("click", function () {
      if (target) {
        const targetPosition = target.getBoundingClientRect().top + window.scrollY;
        const offset = window.innerHeight * 0.2; // 10% of viewport height

        window.scrollTo({
          top: targetPosition - offset,
          behavior: "smooth"
        });
      }
    });
  });
});


// ---------------------

  document.addEventListener("DOMContentLoaded", function () {
    const nav = document.querySelector(".membership-navigation");

    window.addEventListener("scroll", function () {
      const scrollTop = window.scrollY || window.pageYOffset;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = (scrollTop / docHeight) * 100;

      if (scrollPercent >= 0) {
        nav.classList.add("show-cls");
      } else {
        nav.classList.remove("show-cls");
      }
    });
  });



  // document.addEventListener("DOMContentLoaded", function () {
  //     const selectedRepText = document.getElementById("selectedRepText");
  //     const repInput = document.getElementById("repPropertyInput");

  //     function getRepIdentifierFromURL() {
  //       const urlParams = new URLSearchParams(window.location.search);
  //       const ciliKey = urlParams.get("cilikey") || urlParams.get("ciliprivatekey");
  //     if (ciliKey) {
  //         localStorage.setItem('manualMemberSelected', 'false');
  //       }
  //       if (ciliKey) return ciliKey;

  //       const pathParts = window.location.pathname.split("/").filter(Boolean);
  //       if (pathParts.length === 1 && pathParts[0].toLowerCase() !== "pages") {
  //         return pathParts[0];
  //       }

  //       return null;
  //     }

  //     function displayRep(rep) {
  //       const fullName = `${rep.first_name?.trim() || ""} ${rep.last_name?.trim() || ""}`.trim();
  //       const displayName = fullName || rep.handle || `Rep #${rep["rep_#"]}`;
        
  //       if (selectedRepText) selectedRepText.textContent = displayName;
  //       if (repInput) repInput.value = displayName;

  //       localStorage.setItem("selectedRep", JSON.stringify(rep));
  //       console.log("✅ Rep matched and stored:", displayName);
  //     }

  //     function fetchByShareKey(identifier) {
  //       const url = `https://cbd.kwik.dev/ords/cbd/pub/rep/shareLink/${encodeURIComponent(identifier)}`;
  //       return fetch(url)
  //         .then(res => {
  //           if (!res.ok) throw new Error("Not a valid share key");
  //           return res.json();
  //         })
  //         .then(data => {
  //           const rep = data.items?.[0];
  //           if (rep) {
  //             displayRep(rep);
  //             return true; 
  //           }
  //           return false;
  //         });
  //     }

  //     function fetchBySearch(identifier) {
  //       const cleaned = identifier.trim();
  //       const searchKey = cleaned;
  //       const url = `https://cbd.kwik.dev/ords/cbd/pub/rep/search/${encodeURIComponent(searchKey)}`;

  //       return fetch(url)
  //         .then(res => res.json())
  //         .then(data => {
  //           const reps = data.items || [];
  //           const normalizedInput = cleaned.toLowerCase().replace(/\s+/g, "").replace(/[,]/g, "");

  //           const matchedRep = reps.find(rep => {
  //             const fullName = `${rep.first_name || ""} ${rep.last_name || ""}`
  //               .toLowerCase()
  //               .replace(/\s+/g, "")
  //               .replace(/[,]/g, "");
  //             const websiteName = rep.website_name?.toLowerCase().trim() || "";
  //             const shareKey = rep.sharelink_key?.toLowerCase().trim() || "";
  //             const repId = String(rep["rep_#"]);

  //             return (
  //               fullName === normalizedInput ||
  //               websiteName === cleaned.toLowerCase() ||
  //               shareKey === cleaned.toLowerCase() ||
  //               repId === cleaned
  //             );
  //           });

  //           const finalRep = matchedRep || reps[0];
  //           if (finalRep) {
  //             displayRep(finalRep);
  //           } else {
  //             console.warn("No rep matched.");
  //           }
  //         })
  //         .catch(err => {
  //           console.error("Rep search error:", err);
  //         });
  //     }


  //     async function resolveAndSetRep() {
  //       const identifier = getRepIdentifierFromURL();
  //       if (!identifier) return;

  //       try {
  //         const success = await fetchByShareKey(identifier);
  //         if (!success) await fetchBySearch(identifier); 
  //       } catch (err) {
  //         console.warn("Trying fallback search due to error:", err);
  //         await fetchBySearch(identifier);
  //       }
  //     }

  //     resolveAndSetRep();
  // });




function enableLastStepMember() {
  $('.CILI-member.rightlaststep.subdisable').removeClass('subdisable');
}
setInterval(enableLastStepMember, 500);



setInterval(() => {
  const stored = localStorage.getItem("selectedRep");

  if (stored) {
    document.querySelectorAll('.rightlaststep').forEach(el => {
      el.classList.remove('subdisable');
    });

    const checkoutBtnOne = document.querySelector('.hel1.checkout-btn');
    if (checkoutBtnOne) {
      checkoutBtnOne.classList.remove('disabled');
      checkoutBtnOne.removeAttribute('disabled');
    }

    const checkoutBtnTwo = document.querySelector('.hel2.checkout-btn');
    if (checkoutBtnTwo) {
      checkoutBtnTwo.classList.remove('disabled');
      checkoutBtnTwo.removeAttribute('disabled');
    }
  }
}, 300);




document.addEventListener("DOMContentLoaded", function () {
  const allNoRepButtons = document.querySelectorAll(".noRepBtn");
  const repModal = document.getElementById("repModal");
  const closeRepModal = document.getElementById("closeRepModal");

  // Toggle leadGenFields visibility
  allNoRepButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      const wrapper = btn.closest(".lead-gen-wrapper");
      const leadGenFields = wrapper.querySelector(".leadGenFields");

      if (leadGenFields) {
        const isVisible = leadGenFields.style.display === "block";
        leadGenFields.style.display = isVisible ? "none" : "block";
      }
    });
  });

  // Close popup
  if (closeRepModal) {
    closeRepModal.addEventListener("click", function () {
      repModal.style.display = "none";
    });
  }

  // Detect if form was submitted successfully via Shopify (URL param)
  const urlParams = new URLSearchParams(window.location.search);
  const contactPosted = urlParams.get("contact_posted");

  if (contactPosted === "true") {
    setTimeout(function () {
      const wrapper = document.querySelector(".lead-gen-wrapper");
      const successMessage = wrapper?.querySelector(".thank-you-message, .form__message--success, .note.form-success, .contact-form__success");

      if (successMessage && repModal) {
        // Open the popup automatically after success
        repModal.style.display = "flex";

        // Optional: remove ?contact_posted=true from URL (so popup doesn’t reopen on refresh)
        const cleanUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, document.title, cleanUrl);
      }
    }, 800);
  }
});
 // ---------------------------------------------------------------------------------------------------------------

 function processProducts(selector, label) {
  const products = document.querySelectorAll(selector);

  if (products.length === 0) {
    console.warn(`No ${selector} elements found.`);
    return;
  }

  products.forEach((product, idx) => {
    const priceElement = product.querySelector(".product-price .current-price span");
    if (!priceElement) {
      console.warn(` No price element found for ${label} [${idx}]`);
      return;
    }

    const spanPrice = priceElement.innerText.trim();
    const cleanPrice = spanPrice.replace(/[^0-9.]/g, "");
    product.setAttribute("data-price", cleanPrice);

    console.log(`${label} [${idx}]`);
    console.log("Raw Price Text:", spanPrice);
    console.log("Clean Price:", cleanPrice);
    console.log("Data Attribute Price:", product.getAttribute("data-price"));
  });
}

function updateAllProducts() {
  processProducts(".product-section", "Product Section");
  processProducts(".product-item", "Product Item");
}

// setInterval(updateAllProducts, 500);







// click functionality for enrollment page

// $(document).ready(function () {
//   $(".custom-step-list li").on("click", function () {
//     const stepIndex = $(this).index() + 1;

//     $(".custom-step-list li").removeClass("active");
//     $(this).addClass("active");
//     $(this).addClass("click");

//     $(".custom-product-left-content .membership").removeClass("active");
//     $('.custom-product-left-content .membership[data-index="' + stepIndex + '"]').addClass("active");

//     if (stepIndex === 2 || stepIndex === 3) {
//       $(".membership-navigation.show-cls").addClass("active");
//     } else {
//       $(".membership-navigation.show-cls").removeClass("active");
//     }
//   });
// });

// document.addEventListener("DOMContentLoaded", function () {
//   const selectedRepText = document.getElementById("selectedRepText");
//   const repInput = document.getElementById("repPropertyInput");

//   function getRepIdentifierFromURL() {
//     const urlParams = new URLSearchParams(window.location.search);
//     const ciliKey = urlParams.get("cilikey") || urlParams.get("ciliprivatekey");
//     if (ciliKey) {
//       console.log("🟡 Found cilikey in URL:", ciliKey);
//       // Reset manual selection since URL param is forcing rep
//       localStorage.setItem('manualMemberSelected', 'false');
//       return ciliKey;
//     }

//     // fallback: use URL path if structure allows
//     const pathParts = window.location.pathname.split("/").filter(Boolean);
//     if (pathParts.length === 1 && pathParts[0].toLowerCase() !== "pages") {
//       return pathParts[0];
//     }

//     return null;
//   }

//   function displayRep(rep) {
//     const fullName = `${rep.first_name?.trim() || ""} ${rep.last_name?.trim() || ""}`.trim();
//     const displayName = fullName || rep.handle || `Rep #${rep["rep_#"]}`;

//     const selectedRepText = document.getElementById("selectedRepText");
//     if (selectedRepText) selectedRepText.textContent = displayName;

//     const repInput = document.getElementById("repPropertyInput");
//     if (repInput) repInput.value = displayName;


//     localStorage.setItem("selectedRep", JSON.stringify(rep));
//     console.log("✅ Rep matched and stored:", displayName);

//     const photoContainer = document.querySelector(".memmer_photo");
//     if (photoContainer) {
//       photoContainer.innerHTML = ""; 
//       if (rep.photo_url) {
//         const img = document.createElement("img");
//         img.src = rep.photo_url;
//         img.alt = displayName;
//         img.className = "rep-photo-img";
//         photoContainer.appendChild(img);
//       }
//     }
//   }


//   function fetchByShareKey(identifier) {
//     const url = `https://cbd.kwik.dev/ords/cbd/pub/rep/shareLink/${encodeURIComponent(identifier)}`;
//     console.log("🌐 Fetching rep by share key:", url);
//     return fetch(url)
//       .then(res => {
//         if (!res.ok) throw new Error("Not a valid share key");
//         return res.json();
//       })
//       .then(data => {
//         const rep = data.items?.[0];
//         if (rep) {
//           displayRep(rep);
//               const cleanURL = new URL(window.location.href);
//               cleanURL.searchParams.delete("cilikey");
//               cleanURL.searchParams.delete("ciliprivatekey");
//               setTimeout(() => {
//                 window.location.replace(cleanURL.toString());
//               }, 500);

//           return true;
//         }
//         return false;
//       })
//       .catch(err => {
//         console.warn("Share key fetch failed:", err);
//         return false;
//       });
//   }

//   function fetchBySearch(identifier) {
//     const cleaned = identifier.trim();
//     const url = `https://cbd.kwik.dev/ords/cbd/pub/rep/search/${encodeURIComponent(cleaned)}`;
//     console.log("🌐 Fallback search for:", cleaned);

//     return fetch(url)
//       .then(res => res.json())
//       .then(data => {
//         const reps = data.items || [];
//         const normalizedInput = cleaned.toLowerCase().replace(/\s+/g, "").replace(/[,]/g, "");

//         const matchedRep = reps.find(rep => {
//           const fullName = `${rep.first_name || ""} ${rep.last_name || ""}`
//             .toLowerCase()
//             .replace(/\s+/g, "")
//             .replace(/[,]/g, "");
//           const websiteName = rep.website_name?.toLowerCase().trim() || "";
//           const shareKey = rep.sharelink_key?.toLowerCase().trim() || "";
//           const repId = String(rep["rep_#"]);

//           return (
//             fullName === normalizedInput ||
//             websiteName === cleaned.toLowerCase() ||
//             shareKey === cleaned.toLowerCase() ||
//             repId === cleaned
//           );
//         });

//         const finalRep = matchedRep || reps[0];
//         if (finalRep) {
//           displayRep(finalRep);
//         } else {
//           console.warn("⚠️ No rep matched in search.");
//         }
//       })
//       .catch(err => {
//         console.error("Rep search error:", err);
//       });
//   }

//   async function resolveAndSetRep() {
//     const path = window.location.pathname.toLowerCase();
//     if (path === "/cart" || path.startsWith("/checkout")) {
//       console.log("🛑 Skipping rep auto-resolve on cart/checkout page");
//       // ✅ Just show stored rep if available
//       const stored = localStorage.getItem('selectedRep');
//       if (stored) {
//         try {
//           displayRep(JSON.parse(stored));
//         } catch (e) {
//           console.warn("Failed to parse stored rep:", e);
//         }
//       }
//       return;
//     }

//     const urlParams = new URLSearchParams(window.location.search);
//     const ciliKeyInURL = urlParams.get("cilikey") || urlParams.get("ciliprivatekey");

//     if (ciliKeyInURL) {
//       console.log("🔄 URL contains ciliKey, forcing reset of manualMemberSelected");
//       localStorage.setItem('manualMemberSelected', 'false');
//     }

//     const manualSelected = localStorage.getItem('manualMemberSelected') === 'true';
//     if (manualSelected) {
//       console.log("🛑 Manual rep already selected — skipping auto-resolve.");
//       const stored = localStorage.getItem('selectedRep');
//       if (stored) {
//         try {
//           displayRep(JSON.parse(stored));
//         } catch (e) {
//           console.warn("Failed to parse stored rep:", e);
//         }
//       }
//       return;
//     }

//     const identifier = getRepIdentifierFromURL();
//     console.log("🔍 Resolved identifier:", identifier);
//     if (!identifier) {
//       console.warn("❌ No identifier found in URL or path.");
//       return;
//     }

//     try {
//       const success = await fetchByShareKey(identifier);
//       if (!success) await fetchBySearch(identifier);
//     } catch (err) {
//       console.warn("Trying fallback search due to error:", err);
//       await fetchBySearch(identifier);
//     }
//   }


//   resolveAndSetRep();
// });



document.addEventListener("DOMContentLoaded", function () {

    const storedRep = localStorage.getItem("selectedRep");
  if (storedRep) {
    try {
      const rep = JSON.parse(storedRep);
      displayRep(rep); // 👈 This restores name + photo immediately on refresh
    } catch (e) {
      console.warn("Failed to parse stored rep:", e);
    }
  }

  const selectedRepText = document.getElementById("selectedRepText");
  const repInput = document.getElementById("repPropertyInput");

  function getRepIdentifierFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const ciliKey =
      urlParams.get("cilikey") ||
      urlParams.get("ciliprivatekey") ||
      urlParams.get("from"); // ✅ Added support for 'from'
    if (ciliKey) {
      console.log("🟡 Found rep identifier in URL:", ciliKey);
      localStorage.setItem("manualMemberSelected", "false");
      return ciliKey;
    }

    // fallback: use URL path if structure allows
    const pathParts = window.location.pathname.split("/").filter(Boolean);
    if (pathParts.length === 1 && pathParts[0].toLowerCase() !== "pages") {
      return pathParts[0];
    }

    return null;
  }

    function displayRep(rep) {
      const fullName = `${rep.first_name?.trim() || ""} ${rep.last_name?.trim() || ""}`.trim();
      const displayName = fullName || rep.handle || `Rep #${rep["rep_#"]}`;

      const selectedRepText = document.getElementById("selectedRepText");
      if (selectedRepText) selectedRepText.textContent = displayName;

      const repInput = document.getElementById("repPropertyInput");
      if (repInput) repInput.value = displayName;

      // ✅ Keep it stored for future refresh
      localStorage.setItem("selectedRep", JSON.stringify(rep));

      const photoContainer = document.querySelector(".memmer_photo");
      if (photoContainer) {
        photoContainer.innerHTML = "";
        if (rep.photo_url) {
          const img = document.createElement("img");
          img.src = rep.photo_url;
          img.alt = displayName;
          img.className = "rep-photo-img";
          photoContainer.appendChild(img);
        }
      }
    }

  function fetchByShareKey(identifier) {
    const url = `https://cbd.kwik.dev/ords/cbd/pub/rep/shareLink/${encodeURIComponent(identifier)}`;
    console.log("🌐 Fetching rep by share key:", url);
    return fetch(url)
      .then(res => {
        if (!res.ok) throw new Error("Not a valid share key");
        return res.json();
      })
      .then(data => {
        const rep = data.items?.[0];
        if (rep) {
          displayRep(rep);
          const cleanURL = new URL(window.location.href);
          cleanURL.searchParams.delete("cilikey");
          cleanURL.searchParams.delete("ciliprivatekey");
          cleanURL.searchParams.delete("from"); // ✅ remove 'from'
          setTimeout(() => {
            window.location.replace(cleanURL.toString());
          }, 500);
          return true;
        }
        return false;
      })
      .catch(err => {
        console.warn("Share key fetch failed:", err);
        return false;
      });
  }

  // When a handle resolves to more than one rep (e.g. shared test handles),
  // prefer the rep whose name matches the handle, otherwise take the first.
  function pickHandleRep(reps, handleValue) {
    if (!reps || !reps.length) return null;
    if (reps.length === 1) return reps[0];
    const norm = String(handleValue).toLowerCase().replace(/\s+/g, "").replace(/[,]/g, "");
    const match = reps.find(rep => {
      const fullName = `${rep.first_name || ""} ${rep.last_name || ""}`
        .toLowerCase().replace(/\s+/g, "").replace(/[,]/g, "");
      return fullName === norm;
    });
    return match || reps[0];
  }

  // Resolve a rep by handle / retail-web-site-name (the ?from value).
  function fetchByHandle(identifier) {
    const url = `https://cbd.kwik.dev/ords/cbd/pub/handle/${encodeURIComponent(identifier)}`;
    console.log("🌐 Fetching rep by handle:", url);
    return fetch(url)
      .then(res => {
        if (!res.ok) throw new Error("Not a valid handle");
        return res.json();
      })
      .then(data => {
        const rep = pickHandleRep(data.items || [], identifier);
        if (rep) {
          displayRep(rep);
          const cleanURL = new URL(window.location.href);
          cleanURL.searchParams.delete("cilikey");
          cleanURL.searchParams.delete("ciliprivatekey");
          cleanURL.searchParams.delete("from");
          setTimeout(() => {
            window.location.replace(cleanURL.toString());
          }, 500);
          return true;
        }
        return false;
      })
      .catch(err => {
        console.warn("Handle fetch failed:", err);
        return false;
      });
  }

  function fetchBySearch(identifier) {
    const cleaned = identifier.trim();
    const url = `https://cbd.kwik.dev/ords/cbd/pub/rep/search/${encodeURIComponent(cleaned)}`;
    console.log("🌐 Fallback search for:", cleaned);

    return fetch(url)
      .then(res => res.json())
      .then(data => {
        const reps = data.items || [];
        const normalizedInput = cleaned.toLowerCase().replace(/\s+/g, "").replace(/[,]/g, "");

        const matchedRep = reps.find(rep => {
          const fullName = `${rep.first_name || ""} ${rep.last_name || ""}`
            .toLowerCase()
            .replace(/\s+/g, "")
            .replace(/[,]/g, "");
          const websiteName = rep.website_name?.toLowerCase().trim() || "";
          const shareKey = rep.sharelink_key?.toLowerCase().trim() || "";
          const repId = String(rep["rep_#"]);

          return (
            fullName === normalizedInput ||
            websiteName === cleaned.toLowerCase() ||
            shareKey === cleaned.toLowerCase() ||
            repId === cleaned
          );
        });

        const finalRep = matchedRep || reps[0];
        if (finalRep) {
          displayRep(finalRep);
        } else {
          console.warn("⚠️ No rep matched in search.");
        }
      })
      .catch(err => {
        console.error("Rep search error:", err);
      });
  }

  async function resolveAndSetRep() {
    const path = window.location.pathname.toLowerCase();
    if (path === "/cart" || path.startsWith("/checkout")) {
      console.log("🛑 Skipping rep auto-resolve on cart/checkout page");
      const stored = localStorage.getItem("selectedRep");
      if (stored) {
        try {
          displayRep(JSON.parse(stored));
        } catch (e) {
          console.warn("Failed to parse stored rep:", e);
        }
      }
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const ciliKeyInURL =
      urlParams.get("cilikey") ||
      urlParams.get("ciliprivatekey") ||
      urlParams.get("from"); // ✅ handle 'from' here too

    if (ciliKeyInURL) {
      console.log("🔄 URL contains rep key, forcing reset of manualMemberSelected");
      localStorage.setItem("manualMemberSelected", "false");
    }

    const manualSelected = localStorage.getItem("manualMemberSelected") === "true";
    if (manualSelected) {
      console.log("🛑 Manual rep already selected — skipping auto-resolve.");
      const stored = localStorage.getItem("selectedRep");
      if (stored) {
        try {
          displayRep(JSON.parse(stored));
        } catch (e) {
          console.warn("Failed to parse stored rep:", e);
        }
      }
      return;
    }

    const identifier = getRepIdentifierFromURL();
    console.log("🔍 Resolved identifier:", identifier);
    if (!identifier) {
      console.warn("❌ No identifier found in URL or path.");
      return;
    }

    // Route to the correct lookup:
    //   ?cilikey / ?ciliprivatekey → share-link endpoint
    //   ?from (or a bare path handle) → handle endpoint
    // Fall back to a name search if the primary lookup misses.
    const cilikeyParam = urlParams.get("cilikey") || urlParams.get("ciliprivatekey");
    try {
      const success = cilikeyParam
        ? await fetchByShareKey(identifier)
        : await fetchByHandle(identifier);
      if (!success) await fetchBySearch(identifier);
    } catch (err) {
      console.warn("Trying fallback search due to error:", err);
      await fetchBySearch(identifier);
    }
  }

  resolveAndSetRep();
});

// ---------------------------------hexompt widget in header----------------
 document.addEventListener('DOMContentLoaded', function () {
    const observer = new MutationObserver(() => {
      const floatDiv = document.querySelector('.ht-tms--float');
      const localization = document.querySelector('.localization-wrapper');

      if (floatDiv && localization) {
        localization.prepend(floatDiv); // first position
        observer.disconnect(); // remove if re-injected later
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });




  
// ---------------------------------
(function () {

  let mutationTimer = null;

  function updateSubscriptionPrices() {
    const cartItems = document.querySelectorAll(
      '.cart-items tbody .cart-item'
    );

    if (!cartItems.length) return;

    // 🔹 Check if any subscription trigger item exists in cart
    let hasSwishSubscription = false;
    cartItems.forEach((item) => {
      const nameEl = item.querySelector('.cart-item__name');
      if (!nameEl) return;
      const name = nameEl.textContent.trim();
      if (
        name.includes('Subscription - CILI AGELESS Swish') ||
        name.includes('Subscription - CILI CBD/CBG Swish')
      ) {
        hasSwishSubscription = true;
      }
    });

    let totalSubscriptionPrice = 0;
    let hasSubscriptionItem = false;

    cartItems.forEach((item) => {
      const nameEl = item.querySelector('.cart-item__name');
      const itemName = nameEl ? nameEl.textContent.trim() : '';

      // 🔹 If swish subscription exists and this item name contains "Spray" → force $0
      const isSprayForcedFree = hasSwishSubscription && itemName.includes('Spray');

      const priceAttr = item.getAttribute('data-key-supsription-price');

      // ❌ No subscription price AND not a forced-free spray → restore money visibility
      if (!priceAttr && !isSprayForcedFree) {
        item.querySelectorAll('.money').forEach(el => {
          el.style.display = '';
        });

        // Remove any leftover subscription-price-info
        const leftover = item.querySelector('.subscription-price-info');
        if (leftover) leftover.remove();

        return;
      }

      // ✅ Either has subscription price OR is a forced-free spray
      hasSubscriptionItem = true;

      // Hide all money inside this cart item
      item.querySelectorAll('.money').forEach(el => {
        el.style.display = 'none';
      });

      let itemTotal;

      if (isSprayForcedFree) {
        // Force price to 0 for spray items when swish subscription is present
        itemTotal = 0;
      } else {
        const quantityInput = item.querySelector('input.quantity__input');
        const quantity = quantityInput ? parseInt(quantityInput.value) : 1;
        const price = parseFloat(priceAttr);
        itemTotal = price * quantity;
      }

      totalSubscriptionPrice += itemTotal;

      const detailsContainer = item.querySelector('.cart-item__details');
      if (!detailsContainer) return;

      let existing = detailsContainer.querySelector('.subscription-price-info');
      const text = `Subscription price will be: $${itemTotal.toFixed(2)}`;

      if (!existing) {
        existing = document.createElement('div');
        existing.className = 'subscription-price-info';
        existing.style.marginTop = '5px';
        existing.style.fontSize = '14px';
        existing.textContent = text;
        detailsContainer.appendChild(existing);
      } else {
        existing.textContent = text;
      }
    });

    /* -----------------------------
       Footer Total Subscription
    ------------------------------ */

    const footer = document.querySelector(
      '.drawer__footer .cart-drawer__footer'
    );

    if (!footer) return;

    let totalElement = footer.querySelector('.total-subscription-price');
    const totalText = `Total product price will be: $${totalSubscriptionPrice.toFixed(2)}`;

    if (!totalElement) {
      totalElement = document.createElement('div');
      totalElement.className = 'total-subscription-price';
      totalElement.style.fontWeight = '600';
      totalElement.style.marginBottom = '10px';
      totalElement.style.textAlign = 'center';
      totalElement.textContent = totalText;
      footer.prepend(totalElement);
    } else {
      totalElement.textContent = totalText;
    }

    /* -----------------------------
       Hide .totals if needed
    ------------------------------ */

    const totalsWrapper = document.querySelector('.totals');
    const totalMoney = document.querySelector(
      '.totals__total-value .money'
    );

    if (totalsWrapper && totalMoney && hasSubscriptionItem) {
      const numericValue = parseFloat(
        totalMoney.textContent.replace(/[^0-9.-]+/g, '')
      );

      if (numericValue === 0) {
        totalsWrapper.style.display = 'none';
      } else {
        totalsWrapper.style.display = '';
      }
    } else if (totalsWrapper) {
      totalsWrapper.style.display = '';
    }
  }

  window.updateSubscriptionPrices = updateSubscriptionPrices;

  document.addEventListener("DOMContentLoaded", function () {
    const cartDrawer = document.querySelector('cart-drawer, .cart-drawer');
    if (!cartDrawer) return;

    const observer = new MutationObserver(() => {
      clearTimeout(mutationTimer);
      mutationTimer = setTimeout(() => {
        updateSubscriptionPrices();
      }, 800);
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });

    setTimeout(updateSubscriptionPrices, 800);
  });
  
})();

document.querySelectorAll('.membership .select-your-products .product-subsciption-loop .product-item')
  .forEach(function(item) {
    item.setAttribute('data-rv-meta', '0');
    item.setAttribute('data-bv-meta', '0');
    item.setAttribute('data-wv-meta', '0');
  });


document.addEventListener("DOMContentLoaded", () => {

  // ----------------------------
  // CART DRAWER HELPERS
  // ----------------------------

  function openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else {
      cartDrawer?.classList.add('active');
      document.body.classList.add('overflow-hidden');
    }
  }

  function bindOverlayClose() {
    if (!window.location.pathname.includes('/collections/subscription-product')) return;

    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
    if (!overlay) return;

    overlay.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopPropagation();

        cartDrawer.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      },
      true
    );
  }

  async function refreshCartDrawer() {
    const res = await fetch('/?sections=cart-drawer');
    const data = await res.json();

    const oldDrawer = document.querySelector('cart-drawer');
    if (!oldDrawer || !data['cart-drawer']) return;

    const newDrawer = new DOMParser()
      .parseFromString(data['cart-drawer'], 'text/html')
      .querySelector('cart-drawer');

    if (newDrawer) {
      oldDrawer.replaceWith(newDrawer);
      bindOverlayClose();
    }
  }

  async function openAndRefreshDrawer() {
    await refreshCartDrawer();
    openCartDrawer();
  }

  // ----------------------------
  // CART API HELPERS
  // ----------------------------

  function getCart() {
    return fetch('/cart.js').then(res => res.json());
  }

  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: qty
      })
    }).then(res => res.json());
  }

  function updateCartByKey(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: qty
      })
    }).then(res => res.json());
  }

  // ----------------------------
  // PRODUCT CARD LOGIC
  // ----------------------------
// ─── Core sync: reads live cart and updates all product cards ────────────────
async function syncAllProductCards() {
  const cart = await getCart();

  document.querySelectorAll(".quick-add__submit").forEach(button => {
    const form = button.closest("form");
    const qtyWrapper = form?.querySelector(".card-qty");
    if (!qtyWrapper) return;

    const variantId = qtyWrapper.dataset.variantId;
    const qtyCountEl = qtyWrapper.querySelector(".qty-count");

    const totalQty = cart.items
      .filter(i => String(i.id) === String(variantId))
      .reduce((sum, i) => sum + i.quantity, 0);

    if (totalQty > 0) {
      qtyWrapper.classList.remove("hidden");
      button.classList.add("hidden");
      qtyCountEl.textContent = totalQty;
    } else {
      qtyWrapper.classList.add("hidden");
      button.classList.remove("hidden");
    }
  });
}

// ─── Listen to Shopify's native cart events (fired after drawer updates) ─────
// These fire AFTER Shopify has finished its own AJAX + re-render
document.addEventListener("cart:updated", syncAllProductCards);
document.addEventListener("cart:refresh", syncAllProductCards);

// Shopify theme default event (Dawn and most paid themes use this)
document.addEventListener("CartDrawer:afterRefresh", syncAllProductCards);

// Some themes dispatch on the document as a CustomEvent after fetch
document.addEventListener("on:cart:update", syncAllProductCards);

// ─── Fallback: intercept Shopify's own fetch calls to /cart/* endpoints ──────
// This catches drawer +/- and remove without needing to know the event name
const _originalFetch = window.fetch;
window.fetch = async function (...args) {
  const result = await _originalFetch.apply(this, args);

  const url = typeof args[0] === "string" ? args[0] : args[0]?.url ?? "";
  const isCartChange =
    url.includes("/cart/change") ||
    url.includes("/cart/add") ||
    url.includes("/cart/update") ||
    url.includes("/cart/clear");

  if (isCartChange) {
    // Clone so Shopify can still read the response body normally
    const clone = result.clone();
    clone.json().then(() => {
      // Give the drawer 100ms to finish re-rendering its HTML, then sync cards
      setTimeout(syncAllProductCards, 100);
    }).catch(() => {});
  }

  return result;
};

// ─── XMLHttpRequest fallback (some older Shopify themes use XHR not fetch) ───
const _originalOpen = XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open = function (method, url, ...rest) {
  this._url = url;
  return _originalOpen.apply(this, [method, url, ...rest]);
};

const _originalSend = XMLHttpRequest.prototype.send;
XMLHttpRequest.prototype.send = function (...args) {
  this.addEventListener("load", () => {
    if (
      this._url?.includes("/cart/change") ||
      this._url?.includes("/cart/update") ||
      this._url?.includes("/cart/add")
    ) {
      setTimeout(syncAllProductCards, 100);
    }
  });
  return _originalSend.apply(this, args);
};

// ─── Product card setup (unchanged logic, just calls global sync) ─────────────
// document.querySelectorAll(".quick-add__submit").forEach(button => {
//   const form = button.closest("form");
//   const qtyWrapper = form?.querySelector(".card-qty");
//   if (!qtyWrapper) return;

//   const qtyCountEl = qtyWrapper.querySelector(".qty-count");
//   const plusBtn = qtyWrapper.querySelector(".plus");
//   const minusBtn = qtyWrapper.querySelector(".minus");
//   const variantId = qtyWrapper.dataset.variantId;

//   button.addEventListener("click", async (e) => {
//     e.preventDefault();
//     await addToCart(variantId, 1);
//     await syncAllProductCards();
//     await openAndRefreshDrawer();
//   });

//   plusBtn.addEventListener("click", async () => {
//     await addToCart(variantId, 1);
//     await syncAllProductCards();
//     await openAndRefreshDrawer();
//     console.log("clicked recommended product plus button");
//   });

//   minusBtn.addEventListener("click", async () => {
//     const cart = await getCart();
//     const item = cart.items.find(i => String(i.id) === String(variantId));
//     if (!item) return;
//     await updateCartByKey(item.key, item.quantity - 1);
//     await syncAllProductCards();
//     await openAndRefreshDrawer();
//     console.log("clicked recommended product minus button");
//   });
// });

  document.addEventListener("click", async (e) => {

    // Add to Cart button
    const addBtn = e.target.closest(".quick-add__submit");

    if (addBtn) {
      e.preventDefault();

      const form = addBtn.closest("form");
      const qtyWrapper = form?.querySelector(".card-qty");

      if (!qtyWrapper) return;

      const variantId = qtyWrapper.dataset.variantId;

      await addToCart(variantId, 1);
      await syncAllProductCards();
      await openAndRefreshDrawer();

setTimeout(() => {
  if (window.location.pathname.includes('/collections/subscription-product')) {
    updateAutoshipMessage();
    updateSubscriptionPrices();
  } else {
    document.getElementById("autoship-date-message")?.remove();
    document.querySelector(".total-subscription-price")?.remove();
  }
}, 800);

      console.log("add to cart clicked", variantId);
      return;
    }

    // Plus button
    const plusBtn = e.target.closest(".plus");

    if (plusBtn) {
      const qtyWrapper = plusBtn.closest(".card-qty");
      if (!qtyWrapper) return;

      const variantId = qtyWrapper.dataset.variantId;

      await addToCart(variantId, 1);
      await syncAllProductCards();
      await openAndRefreshDrawer();

      console.log("plus clicked", variantId);
      return;
    }

    // Minus button
    const minusBtn = e.target.closest(".minus");

    if (minusBtn) {
      const qtyWrapper = minusBtn.closest(".card-qty");
      if (!qtyWrapper) return;

      const variantId = qtyWrapper.dataset.variantId;

      const cart = await getCart();
      const item = cart.items.find(
        i => String(i.id) === String(variantId)
      );

      if (!item) return;

      await updateCartByKey(item.key, item.quantity - 1);
      await syncAllProductCards();
      await openAndRefreshDrawer();

      console.log("minus clicked", variantId);
    }
  });

  // ─── Initial sync on page load ───────────────────────────────────────────────
  syncAllProductCards();

  bindOverlayClose();

});


// -----------------------cili_id parameter for customer-product collection---------------------------
(function () {
    // Get URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const ciliId = urlParams.get('cili_id');
    const fromId = urlParams.get('from');

    // Helper function to set a cookie for 30 days
    function setCookie(name, value) {
        const date = new Date();
        date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));

        document.cookie = `${name}=${encodeURIComponent(value)}; expires=${date.toUTCString()}; path=/`;
    }

    // Set cookies if URL params exist
    if (ciliId) setCookie('cili_id', ciliId);
    if (fromId) setCookie('from_id', fromId);

    // Helper function to get a cookie value
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return decodeURIComponent(parts.pop().split(';').shift());
        }
        return null;
    }

    // Activate if URL params exist OR cookies exist
    const isActive =
        ciliId ||
        fromId ||
        getCookie('cili_id') ||
        getCookie('from_id');

    if (isActive) {
        document
            .querySelectorAll('.login-options-section')
            .forEach(el => el.classList.add('cili-active'));
        document
            .querySelectorAll('.collection-grid-cls')
            .forEach(el => el.classList.add('cili-active'));
    }
})();


// gift product description modal code 

document.addEventListener('click', function (e) {
  const giftModal = document.getElementById('giftDescriptionModal');
  const giftModalContent = giftModal.querySelector('.gift-modal-description-content');

  if (e.target.classList.contains('gift-see-details-btn')) {
    let description = e.target.getAttribute('data-description');

    description = description.replace(/<p>(&nbsp;|\s)*<\/p>/gi, '');

    giftModalContent.innerHTML = description;
    giftModal.style.display = 'flex';
  }

  if (e.target.classList.contains('gift-close-modal') || e.target === giftModal) {
    giftModal.style.display = 'none';
  }
});


  document.addEventListener("DOMContentLoaded", function() {
    const urlParams = new URLSearchParams(window.location.search);
    
    // Check if the specific parameter exists
    if (urlParams.has('from')) {
      // Check if we have already reloaded this page during the current session
      if (!sessionStorage.getItem('enrollment_page_reloaded')) {
        // Set the flag so it doesn't reload again
        sessionStorage.setItem('enrollment_page_reloaded', 'true');
        
        // Execute the reload
        window.location.reload();
      } else {
        // Optional: Clear the flag after a successful reload 
        // so it works again if the user navigates away and comes back later in the same session.
        sessionStorage.removeItem('enrollment_page_reloaded');
      }
    }
  });


  window.addEventListener('DOMContentLoaded', (event) => {
    // 1. Get the current URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    
    // 2. Check if the 'cilikey' parameter exists
    if (urlParams.has('cilikey')) {
      
      // 3. Check sessionStorage to prevent an infinite refresh loop
      if (!sessionStorage.getItem('pageRefreshedForCilikey')) {
        
        // Set the flag immediately so it doesn't try to trigger again
        sessionStorage.setItem('pageRefreshedForCilikey', 'true');
        
        // 4. Wait for 2000 milliseconds (2 seconds) before refreshing
        setTimeout(() => {
          window.location.reload();
        }, 5000); 
      }
    }
  });



// --------- Subscription collection form code ----------\\

document.addEventListener("DOMContentLoaded", () => {
  const params = new URLSearchParams(window.location.search);
  const urlType = params.get("type");
  const localType = localStorage.getItem("enrollment_type");

  const isEnrollmentFlow =
    ["self", "sponsor"].includes(urlType) ||
    ["self", "sponsor"].includes(localType);

  if (!isEnrollmentFlow) return;

  const sponsorStep = document.querySelector(
    ".memberships.sponsor-step"
  );

  const sponsorForm = document.querySelector(
    ".sponsor-form form"
  );

  const countrySelect =
    document.getElementById("country-select");

  const hiddenSections = document.querySelectorAll(
    ".date-step-enroll, .collection-design-2, .swish-promo-section"
  );


  const updateStepHeadings = () => {
    const step1Heading = document.querySelector(
      ".date-step-enroll .heading h2"
    );

    const step2Heading = document.querySelector(
      ".collection-design-2 .heading h2"
    );

    if (step1Heading) {
      step1Heading.textContent = step1Heading.textContent.replace(
        "Step 1:",
        "Step 2:"
      );
    }

    if (step2Heading) {
      step2Heading.textContent = step2Heading.textContent.replace(
        "Step 2:",
        "Step 3:"
      );
    }
  };

  const hideSections = () => {
    hiddenSections.forEach((section) => {
      section.classList.add("form_hidden");
    });

    updateStepHeadings();
  };

  const showSections = () => {
    hiddenSections.forEach((section) => {
      section.classList.remove("form_hidden");
    });
    updateStepHeadings();
  };

  const getSponsorData = () => {
    return JSON.parse(
      localStorage.getItem("sponsorData") || "{}"
    );
  };

  const saveSponsorData = (countryCode, countryName) => {
    const sponsorData = getSponsorData();

    sponsorData.country = countryCode;
    sponsorData.countryName = countryName;

    localStorage.setItem(
      "sponsorData",
      JSON.stringify(sponsorData)
    );
  };

  sponsorStep?.classList.add("active");

  const sponsorData = getSponsorData();

if (sponsorData.country) {
  const option = countrySelect?.querySelector(
    `option[data-value="${sponsorData.country}"]`
  );

  if (option) {
    option.selected = true;

    // sponsorStep?.classList.remove("active");
    showSections();

    // Sync TMS selector on page load
    const dropdown = document.querySelector(
      ".ht-tms-single-dropdown__container--region .ht-tms-dropdown__selected"
    );

    const btn = document.querySelector(
      ".ht-tms__duo-selector__button"
    );

    if (dropdown) {
      setTimeout(() => {
        dropdown.click();

        setTimeout(() => {
          const tmsOption = document.querySelector(
            `.ht-tms-option__item[data-value="${sponsorData.country}"]`
          );

          if (tmsOption) {
            tmsOption.click();
            btn?.click();
          }
        }, 500);
      }, 500);
    }
  }
} else {
  hideSections();
}

sponsorForm?.addEventListener("submit", (e) => {
  e.preventDefault();
   showSections();
  const selectedOption =
    countrySelect.options[countrySelect.selectedIndex];

  const countryCode =
    selectedOption.dataset.value?.trim() || "";

  if (!countryCode) {
    alert("Please select a country.");
    return;
  }

  // Save country
  saveSponsorData(
    countryCode,
    selectedOption.textContent.trim()
  );

  // Sync TMS Country Selector
  const dropdown = document.querySelector(
    ".ht-tms-single-dropdown__container--region .ht-tms-dropdown__selected"
  );

  const btn = document.querySelector(
    ".ht-tms__duo-selector__button"
  );

  if (dropdown) {
    dropdown.click();

    setTimeout(() => {
      const tmsOption = document.querySelector(
        `.ht-tms-option__item[data-value="${countryCode}"]`
      );

      if (tmsOption) {
        tmsOption.click();

        setTimeout(() => {
          btn?.click();

          setTimeout(() => {
            window.location.reload();
          }, 500);
        }, 300);
      } else {
        console.warn(
          `TMS country not found: ${countryCode}`
        );

        window.location.reload();
      }
    }, 500);
  } else {
    window.location.reload();
  }
});

  // GOOGLE AUTOCOMPLETE
  const inputs = sponsorForm?.querySelectorAll("input");

  if (
    inputs &&
    inputs.length >= 5 &&
    window.google
  ) {
    const addressInput = inputs[2];
    const cityInput = inputs[3];
    const zipInput = inputs[4];

    const autocomplete =
      new google.maps.places.Autocomplete(
        addressInput,
        {
          types: ["address"],
          fields: [
            "address_components",
            "formatted_address",
            "geometry",
          ],
        }
      );

  autocomplete.addListener("place_changed", () => {
    const place = autocomplete.getPlace();

    if (!place.geometry) return;

    let city = "";
    let zip = "";
    let country = "";

    place.address_components.forEach((component) => {
      const types = component.types;

      if (
        types.includes("locality") ||
        types.includes("administrative_area_level_2")
      ) {
        city = component.long_name;
      }

      if (types.includes("postal_code")) {
        zip = component.long_name;
      }

      if (types.includes("country")) {
        country = component.short_name;
      }
    });

    addressInput.value =
      place.formatted_address || "";

    cityInput.value = city;
    zipInput.value = zip;

    if (!countrySelect || !country) return;

    const option = countrySelect.querySelector(
      `option[data-value="${country}"]`
    );

    if (!option) return;

    // Update select properly
    countrySelect.value = option.value;

    // Trigger change event
    countrySelect.dispatchEvent(
      new Event("change", {
        bubbles: true,
      })
    );

    // Save complete sponsor data
    const sponsorData = JSON.parse(
      localStorage.getItem("sponsorData") || "{}"
    );

    sponsorData.country = country;
    sponsorData.countryName =
      option.textContent.trim();
    sponsorData.address =
      place.formatted_address || "";
    sponsorData.city = city;
    sponsorData.zip = zip;

    localStorage.setItem(
      "sponsorData",
      JSON.stringify(sponsorData)
    );

    console.log(
      "Sponsor Data Updated:",
      sponsorData
    );
  });
  
  }
});



 document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.date-input-wrapper');
  if (!wrapper) return;

  const STORAGE_KEY = 'stepThreeDate'; // ✅ same key used elsewhere in your checkout logic

  // Restore saved date, or default to today
  const savedDate = localStorage.getItem(STORAGE_KEY);

  const fp = flatpickr(wrapper, {
    wrap: true,
    dateFormat: "Y-m-d",
    minDate: "today",
    defaultDate: savedDate || "today",

    onChange(selectedDates, dateStr, instance) {
      if (dateStr) {
        localStorage.setItem(STORAGE_KEY, dateStr);
      }
    },

    onMonthChange(selectedDates, dateStr, instance) {
      const selected = instance.selectedDates[0];
      const isSameMonth =
        selected &&
        selected.getMonth() === instance.currentMonth &&
        selected.getFullYear() === instance.currentYear;

      instance.calendarContainer.classList.toggle(
        "hide-selected-highlight",
        !isSameMonth
      );
    },

    onOpen(selectedDates, dateStr, instance) {
      instance.calendarContainer.classList.remove("hide-selected-highlight");
    }
  });

  // ✅ Ensure a value is stored on first load if none exists yet
  if (!savedDate) {
    const todayStr = fp.input.value;
    if (todayStr) localStorage.setItem(STORAGE_KEY, todayStr);
  }
});
// document.addEventListener('DOMContentLoaded', function () {
//   const input = document.getElementById('deliveryDate');

//   if (!input) return;

//   // Today's date
//   const minDeliveryDate = new Date();

//   // Add 30 days
//   minDeliveryDate.setDate(minDeliveryDate.getDate() + 30);

//   flatpickr(input, {
//     dateFormat: "Y-m-d",
//     minDate: minDeliveryDate,
//     defaultDate: minDeliveryDate,
//     clickOpens: true,

//     onMonthChange(selectedDates, dateStr, instance) {
//       const selected = instance.selectedDates[0];

//       const isSameMonth =
//         selected &&
//         selected.getMonth() === instance.currentMonth &&
//         selected.getFullYear() === instance.currentYear;

//       instance.calendarContainer.classList.toggle(
//         "hide-selected-highlight",
//         !isSameMonth
//       );
//     },

//     onOpen(selectedDates, dateStr, instance) {
//       instance.calendarContainer.classList.remove("hide-selected-highlight");
//     }
//   });

//   // Open calendar when clicking the icon
//   document.querySelector('.date-icon')?.addEventListener('click', () => {
//     input._flatpickr.open();
//   });
// });


// NOTE: The "prefill checkout" IIFE that used to live here was reverted.
// It wrote referral_* cart attributes and hijacked every checkout click to a
// /cart/<items>?checkout[...] permalink, which clashed with the enrollment
// checkout built in membership.js and with sponsor attribution. Cart metafields
// are now handled by assets/apex-attribution.js (Storefront API, metafields only).

// // // // // // // // // // // / / / / / / / // /

function updateAutoshipMessage() {
  // Run only on the subscription collection page
  if (window.location.pathname !== '/collections/subscription-product') {
    return;
  }

  const dateInput = document.getElementById("deliveryDate");
  const drawerFooter = document.querySelector(".drawer__footer");

  if (!dateInput || !drawerFooter) return;

  let autoshipMsg = document.getElementById("autoship-date-message");

  if (!autoshipMsg) {
    autoshipMsg = document.createElement("div");
    autoshipMsg.id = "autoship-date-message";
    autoshipMsg.style.marginBottom = "10px";
    autoshipMsg.style.fontSize = "14px";
    autoshipMsg.style.fontWeight = "500";
    autoshipMsg.style.textAlign = "center";

    drawerFooter.prepend(autoshipMsg);
  }

  if (!dateInput.value) {
    autoshipMsg.innerHTML = "";
    return;
  }

  const formattedDate = new Date(dateInput.value).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "long",
    year: "numeric"
  });

  autoshipMsg.innerHTML = `Subscription Processes on: <strong>${formattedDate}</strong>`;
}




// js for flag and country name change according to announcement bar start 

function updateShippingBadge() {
  const sourceImg = document.querySelector('.tms-element-flag');
  const sourceText = document.querySelector('.tms-element-text');

  const visibleBadge = document.querySelector(
    '.shipping-badge p[style*="display: block"]'
  );

  if (!visibleBadge) return;

  // Update only image src
  const targetImg = visibleBadge.querySelector('img');
  if (sourceImg && targetImg) {
    targetImg.src = sourceImg.src;
  }

  // Update text
  const targetSpan = visibleBadge.querySelector('span');
  if (sourceText && targetSpan) {
    targetSpan.textContent = `Welcome to our ${sourceText.textContent.trim()} store!`;
  }
}

// Initial run
updateShippingBadge();

// Keep synced with Hextom updates
setInterval(updateShippingBadge, 500);

// js for flag and country name change according to announcement bar end

 

//  for checkout button enable or disabled start 
 

function hasSelectedMember() {
  try {
    const rep = JSON.parse(localStorage.getItem("selectedRep"));
    return !!(rep && (rep.first_name || rep.last_name));
  } catch (e) {
    return false;
  }
}

/* =====================================================
   VISITED STEPS PERSISTENCE
   "visited" used to live only as a DOM class, so any reload dropped steps 2-4
   and the checkout gate demanded a re-walk even though every selection had been
   restored from enrollmentStepData. The page also reloads itself when ?from= is
   present, so this hit people who never pressed refresh.
   Kept in its own key: saveStepData() rebuilds enrollmentStepData from the DOM
   on every write, so a field parked in there would be wiped on the next save.
===================================================== */
const VISITED_STEPS_KEY = "enrollmentVisitedSteps";

function getVisitedSteps() {
  try {
    const raw = JSON.parse(localStorage.getItem(VISITED_STEPS_KEY));
    return Array.isArray(raw) ? raw.map(String) : [];
  } catch (e) {
    return [];
  }
}

function persistVisitedStep(index) {
  if (index === null || index === undefined || index === "") return;
  const idx = String(index);
  const steps = getVisitedSteps();
  if (steps.indexOf(idx) !== -1) return;
  steps.push(idx);
  try {
    localStorage.setItem(VISITED_STEPS_KEY, JSON.stringify(steps));
  } catch (e) {
    // Private mode / quota: degrade to the old in-DOM-only behaviour.
  }
}

function markLiVisited(li) {
  if (!li) return;
  li.classList.add("visited");
  persistVisitedStep(li.getAttribute("data-index"));
}

// Re-apply saved progress. Runs on an interval because the step list is
// re-rendered dynamically well after DOMContentLoaded.
function restoreVisitedSteps() {
  const saved = getVisitedSteps();
  if (!saved.length) return;

  saved.forEach(function (idx) {
    const li = document.querySelector('li.subdisable[data-index="' + idx + '"]');
    if (li) li.classList.add("visited");
  });
}


/* =====================================================
   LI CLICK -> sirf usi li ko visited karo jispar click hua
===================================================== */
document.addEventListener("click", function (e) {
  if (!hasSelectedMember()) return;

  const li = e.target.closest("li.subdisable");   // seedha clicked li
  if (!li) return;

  markLiVisited(li);
  console.log("visited added to li data-index:", li.getAttribute("data-index"));
});


/* =====================================================
   CHECK READY STATE
===================================================== */
function isCheckoutReady() {
  const allSubdisable = document.querySelectorAll("li.subdisable");
  const totalLi = allSubdisable.length;

  let visitedLi = 0;
  allSubdisable.forEach(function (li) {
    if (li.classList.contains("visited")) visitedLi++;
  });

  const allVisited = totalLi > 0 && visitedLi === totalLi;

  // The page renders a .terms-checkbox in both checkout blocks (order summary and
  // .checkout-proceed.rightlaststep). They mirror one consent, so accept either --
  // reading only the first one silently blocked anyone who ticked the last-step box.
  const isChecked = Array.from(
    document.querySelectorAll(".terms-checkbox")
  ).some(function (cb) { return cb.checked; });

  return allVisited && isChecked;
}


/* =====================================================
   WARNING MESSAGE HANDLER
===================================================== */
function handleVisitWarning() {
  const checkoutDiv = document.querySelector(".checkout-buttons-procced");
  if (!checkoutDiv) return;

  const allSubdisable = document.querySelectorAll("li.subdisable");
  const totalLi = allSubdisable.length;

  let visitedLi = 0;
  allSubdisable.forEach(function (li) {
    if (li.classList.contains("visited")) visitedLi++;
  });

  const allVisited = totalLi > 0 && visitedLi === totalLi;

  if (!allVisited) {
    let msg = document.querySelector(".step-visit-warning");
    if (!msg) {
      msg = document.createElement("p");
      msg.className = "step-visit-warning";
      msg.textContent = "Please visit all 4 steps first, then check the “I Agree” box to proceed to checkout.";
      checkoutDiv.parentNode.insertBefore(msg, checkoutDiv);
    }
    document.querySelectorAll(".step-visit-warning").forEach(function (m, i) {
      if (i > 0) m.remove();
    });
  } else {
    document.querySelectorAll(".step-visit-warning").forEach(function (m) {
      m.remove();
    });
  }
}


/* =====================================================
   SETINTERVAL: only runs for members
===================================================== */
setInterval(function () {

  const buyBtns = document.querySelectorAll(".terms-buy-btn.cusCheckout");
  if (!buyBtns.length) return;

  if (!hasSelectedMember()) {
    document.querySelectorAll(".step-visit-warning").forEach(function (m) {
      m.remove();
    });
    return;
  }

  handleVisitWarning();

  // Toggle every checkout button, not just the first: the capture-phase guard
  // below blocks whichever button is clicked, so a stale-looking enabled button
  // swallowed the click with no error.
  const ready = isCheckoutReady();
  buyBtns.forEach(function (buyBtn) {
    // An in-flight enrollment submit owns the button (membership.js greys it
    // out and spins it). Re-enabling it here would hand the shopper a live
    // button mid-submit, which is exactly the double-post this gate prevents.
    if (buyBtn.classList.contains("is-submitting")) return;

    if (ready) {
      buyBtn.disabled = false;
      buyBtn.removeAttribute("disabled");
      buyBtn.classList.remove("disabled");
    } else {
      buyBtn.setAttribute("disabled", "disabled");
      buyBtn.classList.add("disabled");
    }
  });
}, 300);


/* =====================================================
   BLOCK CLICK IF NOT READY (members only)
===================================================== */
document.addEventListener("click", function (e) {
  const btn = e.target.closest(".terms-buy-btn.cusCheckout");
  if (!btn) return;

  if (!hasSelectedMember()) return;

  if (!isCheckoutReady()) {
    e.preventDefault();
    e.stopImmediatePropagation();

    // This guard runs in the capture phase, so stopImmediatePropagation() kills the
    // membership.js .checkout-btn handler before it logs or fetches anything. Say why
    // we blocked, otherwise a blocked checkout looks like a dead button (CILI hotfix).
    const blockedOnTerms = !Array.from(
      document.querySelectorAll(".terms-checkbox")
    ).some(function (cb) { return cb.checked; });

    console.warn(
      "Checkout blocked: " +
        (blockedOnTerms ? "terms not accepted" : "not all steps visited")
    );

    const block = btn.closest(".checkout-buttons-col-1") || document;
    const errorMsg = block.querySelector(".error-msg");
    if (blockedOnTerms && errorMsg) errorMsg.style.display = "block";
  }
}, true);


/* =====================================================
   TERMS CHECKBOX — OWN CONTROL (members only)
===================================================== */
document.addEventListener("click", function (e) {

  const cb = e.target.closest(".terms-checkbox");
  if (!cb) return;

  if (!hasSelectedMember()) return;

  const allSubdisable = document.querySelectorAll("li.subdisable");
  const totalLi = allSubdisable.length;

  let visitedLi = 0;
  allSubdisable.forEach(function (li) {
    if (li.classList.contains("visited")) visitedLi++;
  });

  const allVisited = totalLi > 0 && visitedLi === totalLi;

  if (!allVisited) {
    e.preventDefault();
    e.stopImmediatePropagation();

    document.querySelectorAll(".terms-buy-btn").forEach(function (btn) {
      btn.disabled = true;
      btn.setAttribute("disabled", "disabled");
      btn.classList.add("disabled");
    });

    return;
  }

  setTimeout(function () {
    const isChecked = cb.checked;

    document.querySelectorAll(".terms-buy-btn").forEach(function (btn) {
      if (isChecked) {
        btn.disabled = false;
        btn.removeAttribute("disabled");
        btn.classList.remove("disabled");
      } else {
        btn.disabled = true;
        btn.setAttribute("disabled", "disabled");
        btn.classList.add("disabled");
      }
    });
  }, 0);

}, true);


/* ===================================================== 
   Keeps button disabled while 4 li not visited
===================================================== */
setInterval(function () {

  if (!hasSelectedMember()) return;

  const allSubdisable = document.querySelectorAll("li.subdisable");
  const totalLi = allSubdisable.length;

  let visitedLi = 0;
  allSubdisable.forEach(function (li) {
    if (li.classList.contains("visited")) visitedLi++;
  });

  const allVisited = totalLi > 0 && visitedLi === totalLi;

  if (!allVisited) {
    document.querySelectorAll(".terms-buy-btn").forEach(function (btn) {
      btn.disabled = true;
      btn.setAttribute("disabled", "disabled");
      btn.classList.add("disabled");
    });
  }

}, 250);
 
 
/* =====================================================
   NAV SKIP / PROCEED -> mark li visited
===================================================== */
document.addEventListener("click", function (e) {

  if (!hasSelectedMember()) return;

  const btn = e.target.closest(".skip-button, .proceed");
  if (!btn) return;

  const nav = btn.closest(".membership-navigation");
  if (!nav) return;

  let navStep = nav.getAttribute("data-step");
  if (!navStep) {
    if (nav.classList.contains("step-1")) navStep = "1";
    else if (nav.classList.contains("step-2")) navStep = "2";
    else if (nav.classList.contains("step-3")) navStep = "3";
  }
  if (!navStep) return;

  let indexes = [];
  if (navStep === "1") indexes = ["1"];
  else if (navStep === "2") indexes = ["2"];
  else if (navStep === "3") indexes = ["3", "4"];

  indexes.forEach(function (idx) {
    const li = document.querySelector('li.subdisable[data-index="' + idx + '"]');
    if (li) {
      markLiVisited(li);
      console.log("visited added via nav to li:", idx);
    }
  });

}, true);


/* =====================================================
   SPONSOR SIDEBAR STEP (Affiliate Details) — div, not li
   display block/visible -> visited add ; hidden -> remove
===================================================== */
function isSponsorStepVisible() {
  const step = document.querySelector(".sponsor-sidebar-step");
  if (!step) return false;
  return window.getComputedStyle(step).display !== "none";
}

function syncSponsorStepVisited() {
  const step = document.querySelector(".sponsor-sidebar-step");
  if (!step) return;

  if (isSponsorStepVisible()) {
    if (!step.classList.contains("visited")) step.classList.add("visited");
  } else {
    step.classList.remove("visited");
  }
}

document.addEventListener("DOMContentLoaded", syncSponsorStepVisited);
setInterval(syncSponsorStepVisited, 300);


function markFirstLiVisited() {
  // Reuse this existing timer rather than adding another one.
  restoreVisitedSteps();

  if (!hasSelectedMember()) return;

  const firstLi = document.querySelector('li.subdisable[data-index="1"]');
  if (firstLi && !firstLi.classList.contains("visited")) {
    markLiVisited(firstLi);
    console.log("visited added by default to first li");
  }
}

document.addEventListener("DOMContentLoaded", markFirstLiVisited);
setInterval(markFirstLiVisited, 300);

//  for checkout button enable or disabled end